import type { TextareaHTMLAttributes } from 'react';
import classnames from 'classnames';
import formStyles from '../../styles/form-control.module.scss';
import styles from './Textarea.module.scss';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/** A multi-line text field, in the same look as `Textbox` and `Dropdown`. */
export function Textarea({ className, rows = 4, ...textareaProps }: TextareaProps): JSX.Element {
  return <textarea className={classnames(formStyles.formControl, styles.textarea, className)} rows={rows} {...textareaProps} />;
}
